import React from 'react';
import { Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useUserStore } from '../../../../app/store/useUserStore';
import { isSenderRole, isTravellerRole } from '../../../utils/roleUtils';
import { Tooltip } from '../Tooltip/Tooltip';

export const FloatingActionButton: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useUserStore();

  const handleClick = () => {
    if (isSenderRole(user?.user_role)) {
      navigate('/create-shipment');
    } else if (isTravellerRole(user?.user_role)) {
      navigate('/create-itinerary');
    }
  };

  const tooltipText = isSenderRole(user?.user_role) ? 'Create Item' : 'Create Itinerary';

  return (
    <div className="fixed bottom-4 right-4 sm:bottom-8 sm:right-8 z-50">
      <div className="absolute inset-0 flex items-center justify-center">
        <div
          className="absolute w-10 h-10 sm:w-14 sm:h-14 rounded-full animate-ping"
          style={{
            backgroundColor: 'rgba(136, 19, 85, 0.3)',
            animationDuration: '2s',
            animationDelay: '0s'
          }}
        />
        <div
          className="absolute w-10 h-10 sm:w-14 sm:h-14 rounded-full animate-ping"
          style={{
            backgroundColor: 'rgba(136, 19, 85, 0.2)',
            animationDuration: '2s',
            animationDelay: '0.3s'
          }}
        />
        <div
          className="absolute w-10 h-10 sm:w-14 sm:h-14 rounded-full animate-ping"
          style={{
            backgroundColor: 'rgba(136, 19, 85, 0.15)',
            animationDuration: '2s',
            animationDelay: '0.6s'
          }}
        />
      </div>

      <Tooltip message={tooltipText} placement="top" useTranslation={false}>
        <button
          onClick={handleClick}
          className="relative w-10 h-10 sm:w-14 sm:h-14 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center hover:scale-110"
          style={{
            backgroundColor: '#881355',
          }}
          aria-label="Create"
        >
          <Plus
            size={18}
            className="sm:hidden"
            color="white"
          />
          <Plus
            size={24}
            className="hidden sm:block"
            color="white"
          />
        </button>
      </Tooltip>

      <style>{`
        @keyframes ping {
          0% {
            transform: scale(1);
            opacity: 0.8;
          }
          50% {
            transform: scale(1.5);
            opacity: 0.4;
          }
          100% {
            transform: scale(2);
            opacity: 0;
          }
        }

        .animate-ping {
          animation: ping 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
        }
      `}</style>
    </div>
  );
};